// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_json from "../../../../../rescript/lib/es6/js_json.js";
import * as Env$Catalyst from "../Env.bs.js";

var AppLoggerBindings = {};

function debug(obj) {
  try {
    Android.logDebug(Js_json.serializeExn(obj));
    return ;
  }
  catch (exn){
    if (Env$Catalyst.getWorkingEnv(undefined) !== /* Production */0) {
      console.log("[DEBUG]: ", obj);
      return ;
    } else {
      return ;
    }
  }
}

function error(obj) {
  try {
    Android.logError(Js_json.serializeExn(obj));
    return ;
  }
  catch (exn){
    console.error("[ERROR]: ", obj);
    return ;
  }
}

function info(obj) {
  try {
    Android.logInfo(Js_json.serializeExn(obj));
    return ;
  }
  catch (exn){
    if (Env$Catalyst.getWorkingEnv(undefined) !== /* Production */0) {
      console.info("[INFO]: ", obj);
      return ;
    } else {
      return ;
    }
  }
}

function trace(obj) {
  try {
    Android.logTrace(Js_json.serializeExn(obj));
    return ;
  }
  catch (exn){
    if (Env$Catalyst.getWorkingEnv(undefined) !== /* Production */0) {
      console.info("[TRACE]: ", obj);
      return ;
    } else {
      return ;
    }
  }
}

function warn(obj) {
  try {
    Android.logWarn(Js_json.serializeExn(obj));
    return ;
  }
  catch (exn){
    if (Env$Catalyst.getWorkingEnv(undefined) !== /* Production */0) {
      console.warn("[WARNING]: ", obj);
      return ;
    } else {
      return ;
    }
  }
}

export {
  AppLoggerBindings ,
  debug ,
  error ,
  info ,
  trace ,
  warn ,
  
}
/* No side effect */
